import get from 'lodash.get';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const getPricesStatus = (rootState) =>
  get(status.selectors.getStatus(rootState), statusNames.PRICES);

export default getPricesStatus;
